import React from 'react';
import { Icon } from 'assets/Icon';
import './Footer.scss';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-text">
          <p>Copyright © 2025 Silver Golub &amp; Teitell LLP</p>
          <p>
            <span>Attorney Advertising</span> &#8901; 
            {` `}<a href="https://www.sgtlaw.com/disclaimer">Disclaimer</a> &#8901; 
            {` `}<Link to="/privacy-policy">Privacy Policy</Link> &#8901; 
            {` `}<a href="https://www.sgtlaw.com/credits">Credits</a>
          </p>
        </div>
        <div className="social-links">
          <a href="https://www.linkedin.com/company/silver-golub-&-teitell" aria-label="LinkedIn">
            <Icon name="linkedin" />
          </a>
          <a href="https://x.com/SGTlawCT" aria-label="Twitter">
            <Icon name="twitter" />
          </a>
          <a href="https://www.facebook.com/silvergolubteitellLLP" aria-label="Facebook">
            <Icon name="facebook" />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

